// extracted by mini-css-extract-plugin
export var cePicture = "Picture-module--ce-picture--fe044";
export var centered = "Picture-module--centered--c7e73";
export var left = "Picture-module--left--dcad0";
export var right = "Picture-module--right--31ec0";